<script lang="ts">
	import { trackAction } from '$lib/tracking';
	import { createEventDispatcher } from 'svelte';

	let className = '';
	export { className as class };
	export let tag: 'button' | 'a' = 'button';
	export let variant: 'primary' | 'secondary' | 'secondary-white' = 'primary';
	export let disabled: boolean = false;
	export let trackingLabel = '';

	const dispatch = createEventDispatcher();

	function handleClick(event: MouseEvent) {
		if (trackingLabel) {
			trackAction('content', 'button', trackingLabel);
		}

		dispatch('click', event);
	}
</script>

<svelte:element
	this={tag}
	role={tag === 'button' ? 'button' : 'link'}
	on:click={handleClick}
	class="lpg-button {className}"
	class:primary={variant === 'primary'}
	class:secondary={variant === 'secondary'}
	class:disabled
	data-sveltekit-reload
	disabled={tag === 'button' ? disabled : undefined}
	{...$$restProps}><slot /></svelte:element
>

<style lang="postcss">
	.lpg-button {
		@apply text-copy font-bold border rounded inline-flex justify-center items-center h-10.5 px-6 flex-shrink-0;
	}

	.lpg-button.primary {
		@apply bg-magenta text-white border-transparent hover:bg-magenta-hover focus:bg-magenta-hover active:bg-magenta-active;
	}

	.lpg-button.disabled {
		@apply pointer-events-none opacity-50;
	}

	.lpg-button.primary.disabled {
		@apply bg-gray-11 border-gray-8 text-gray-1;
	}

	.lpg-button.secondary {
		@apply bg-transparent border-gray-4 hover:bg-transparent-hover focus:bg-transparent-hover active:bg-transparent-active;
	}

	.lpg-button.secondary.disabled {
		@apply bg-transparent border-gray-4 text-gray-1;
	}

	.lpg-button.secondary-white {
		@apply border-2 border-white;
	}
</style>
